import api from '../api'

export interface Brand {
  id: string
  name: string
  logo: string | null
  org_id: string
  created_at: string
  updated_at: string
}

export interface CreateBrandData {
  name: string
  logo?: string
}

export interface UpdateBrandData {
  name: string
  logo?: string
}

export interface UploadUrlResponse {
  uploadUrl: string
  key: string
  publicUrl: string
}

export const brandsApi = {
  // Get all brands for the organization
  getBrands: async (): Promise<{ success: boolean; data: Brand[]; count: number }> => {
    const response = await api.get('/marketer/brands')
    return response.data
  },

  // Get a specific brand by ID
  getBrand: async (id: string): Promise<{ success: boolean; data: Brand }> => {
    const response = await api.get(`/marketer/brands/${id}`)
    return response.data
  },

  // Create a new brand
  createBrand: async (
    data: CreateBrandData,
  ): Promise<{ success: boolean; data: Brand; message: string }> => {
    const response = await api.post('/marketer/brands', data)
    return response.data
  },

  // Update an existing brand
  updateBrand: async (
    id: string,
    data: UpdateBrandData,
  ): Promise<{ success: boolean; data: Brand; message: string }> => {
    const response = await api.put(`/marketer/brands/${id}`, data)
    return response.data
  },

  // Delete a brand
  deleteBrand: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/marketer/brands/${id}`)
    return response.data
  },

  // Get presigned URL for logo upload
  getUploadUrl: async (
    fileName: string,
    fileType: string,
  ): Promise<{ success: boolean; data: UploadUrlResponse }> => {
    const response = await api.post('/marketer/brands/upload-url', { fileName, fileType })
    return response.data
  },

  // Upload file to presigned URL
  uploadFile: async (uploadUrl: string, file: File | Blob): Promise<void> => {
    const res = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
        'x-amz-acl': 'public-read',
      },
    })
    if (!res.ok) throw new Error(`Upload failed (${res.status})`)
  },
}
